import React from 'react';

import { Caret, CaretWrapper, SlotWrapper, SlotValue } from './styles';
import { SlotProps } from './types';

const FakeCaret: React.FC = () => {
  return (
    <CaretWrapper>
      <Caret />
    </CaretWrapper>
  );
};

const Slot: React.FC<SlotProps> = ({ value, isFocused, error }) => {
  return (
    <SlotWrapper error={!!error} isFocused={isFocused}>
      {value ? (
        <SlotValue error={!!error}>{value}</SlotValue>
      ) : (
        isFocused && <FakeCaret />
      )}
    </SlotWrapper>
  );
};

export default Slot;
